import { PDFDocument } from 'pdf-lib';
import { PDFName,PDFCheckBox } from 'pdf-lib';
import { rgb, StandardFonts } from 'pdf-lib';
import { filingDebtors } from '../../utils/debtors';
const token = localStorage.getItem("accessToken");
const API_URL2 = process.env.REACT_APP_BACKEND_URL;
function moveUncheckedCheckboxesToCorner(form, pageSize, context) {
  const { width, height } = pageSize;
  form.getFields().forEach(field => {
    // Only target PDFCheckBox fields
    if (field instanceof PDFCheckBox) {
      try {
        if (!field.isChecked()) {
          const widgets = field.acroField.getWidgets();
          widgets.forEach(widget => {
            const dict = widget.acroAnnotation?.dict || widget.dict;
            dict.set(
              PDFName.of('Rect'),
              context.obj([
                width + 5,
                height + 5,
                width + 15,
                height + 15
              ])
            );
          });
        }
      } catch {
        // ignore any errors moving individual checkboxes
      }
    }
  });
}
const fmtDate = (s) => {
      if (!s) return '';
      const [year, month, day] = s.split('-');
      return `${month}/${day}/${year}`;
    };
async function fetchPdf(url) {
  const res = await fetch(url);
  if (!res.ok) throw new Error('Failed to fetch PDF: ' + url);
  return new Uint8Array(await res.arrayBuffer());
}

export async function generateDecPage(caseData) {

    caseData = { ...caseData, debtors: filingDebtors(caseData?.debtors) };

    const decUrl = '/forms/dec.pdf'
    const decExistingPdfBytes = await fetch(decUrl).then(res => res.arrayBuffer());
    const decPdfDoc = await PDFDocument.load(decExistingPdfBytes);
    const decForm = decPdfDoc.getForm();

    (caseData.debtors.filter(d => d.is_filing) || []).forEach((debtor, index) => {
        const amendPrefix = debtor.is_primary ? 'Debtor 1' : 'Debtor 2';
        decForm.getTextField(`${amendPrefix}`).setText(`${(debtor.first_name || '')} ${(debtor.second_name || '')} ${(debtor.last_name || '')} ${(debtor.suffix || '')}`);
    });

    (caseData.debtors.filter(d => d.is_filing) || []).forEach((debtor, index) => {
        const amendPrefix = debtor.is_primary ? 'Debtor1' : 'Debtor2';
        decForm.getTextField(`${amendPrefix}.signature`).setText(`s/ ${(debtor.first_name || '')} ${(debtor.second_name || '')} ${(debtor.last_name || '')} ${(debtor.suffix || '')}`);
        decForm.getTextField(`${amendPrefix}.Executed on`).setText(fmtDate(caseData.execution_date));
    });

    decForm.getCheckBox(`no_preparer`).check();
    decForm.getTextField('case_number').setText(caseData.case_number || '');
    decForm.getTextField('district').setText("Eastern District of Tennessee");

    moveUncheckedCheckboxesToCorner(decForm,decPdfDoc.getPages()[0].getSize(), decPdfDoc.context);
    decForm.flatten();
    const caseDebtors = [];

  const primaryDebtor = caseData?.debtors?.find(d => d.is_primary && d.is_filing);
  const secondaryDebtor = caseData?.debtors?.find(d => !d.is_primary && d.is_filing);
  const nonFilingSpouse = caseData?.debtors?.find(d => !d.is_primary && !d.is_filing);
  caseDebtors.push(primaryDebtor)
    if (secondaryDebtor) caseDebtors.push(secondaryDebtor)
    if (nonFilingSpouse) caseDebtors.push(nonFilingSpouse)

   const filledBytes = await decPdfDoc.save();
const blob = new Blob([filledBytes], { type: 'application/pdf' });
    const formData2 = new FormData();
    formData2.append('file', blob, 'draft.pdf');

  let finalBlob
  
  const primaryName = [primaryDebtor.first_name, primaryDebtor.second_name, primaryDebtor.last_name].filter(Boolean).join(' ');

const response = await fetch(`${API_URL2}/optimize-pdf/`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
        body: formData2,
        credentials: 'include',
      });

      if (response.ok) {
        finalBlob = await response.blob();
      } else {
        console.error("Optimization failed");
        finalBlob = blob;  // fallback to original merged blob
      }

      // Optional: trigger download here
      //const link = document.createElement('a');
      //link.href = URL.createObjectURL(finalBlob);
      //link.download = response.ok ? `${primaryName}_Declaration.pdf` : `${primaryName}_Declaration-failed.pdf`;
      //link.click();

      return finalBlob
}
